module.exports = __webpack_public_path__ + "img/blank-icon.fe9f786e.svg";